module.exports = __webpack_public_path__ + "static/media/SALFORD_APP_LOGO.e2d19448.png";